export interface ApiResponse<T> {
  data?: T;
  success: boolean;
  status?: number;
  totalPages?: number;
  totalCount?: number;
  pageNumber?: number;
  error?: {
    message: string;
    status?: number;
    raw?: unknown;
  };
}
